import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Icon, Input, Checkbox, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {autoFields} from '../../constants';
import {
  validateErrors,
  parseAreas,
  parseUsers,
  parseTechnicianGroups,
} from '../../utils';

const {addNewTechnicianGroup, updateTechnicianGroup, addNewTechnician, updateTechnician, addMessageBoxError} =
  Actions;

const TechnicianGroupForm = ({
  id,
  type,
  addInfo,
  cancelAddInfo,
  currentForm,
  setCurrentForm,
  setEditRow,
  loadingDetail,
  optionsList,
  technicalGroupList,
}) => {
  const dispatch = useDispatch();
  const disableField = type === 'technician' && autoFields.includes(id);

  useEffect(() => {
    if (addInfo) {
      setEditRow('');
      if (type === 'groupTechnician') {
        setCurrentForm({
          'groupId': '',
          'description': '',
          'area': '',
          'status': 'I',
        });
      } else {
        setCurrentForm({
          'technicianId': '',
          'description': '',
          'area': '',
          'relatedUser': '',
          'initials': '',
          'name': '',
          'agency': '',
          'technician': '',
          'status': 'P',
        });
      }
    }
  }, [addInfo]);

  const cancelAddOrEdit = () => {
    cancelAddInfo();
    setCurrentForm({'status': 'I'});
    setEditRow('');
  };

  const saveTechnicianGroup = async() => {
    const {error, message} = validateErrors(type, currentForm);

    if (error) {
      dispatch(addMessageBoxError(message));
      return;
    } else if (type === 'groupTechnician') {
      if (addInfo) {
        dispatch(addNewTechnicianGroup(currentForm));
      } else {
        await dispatch(updateTechnicianGroup(currentForm));
      }
    } else if (type === 'technician') {
      if (addInfo) {
        dispatch(addNewTechnician(currentForm));
      } else {
        dispatch(updateTechnician(currentForm));
      }
    }
    cancelAddOrEdit();
  };

  const onChangeInputValue = (e, {name, value}) => {
    let additionalFields = {};
    
    if (id === 'technicianId') {
      const {description, area} = technicalGroupList.find((group) => group.groupId === value);
      additionalFields = {description, area};
    }
    if (id === 'relatedUser') {
      const {agency, name} = optionsList.find((user) => user.username === value);
      const initials = name.match(/(\b\S)?/g).join('');
      additionalFields = {agency, name, initials};
    }
    let finalValue = value.toUpperCase();
    if (name === 'status') {
      finalValue = value === 'A' ? (type === 'technician' ? 'P' : 'I') : 'A';
    }

    setCurrentForm({...currentForm, ...additionalFields, [name]: finalValue});
  };

  const getParsedoptions = (id) => {
    if (id === 'area') {
      return parseAreas(optionsList);
    }
    if (id === 'relatedUser') {
      return parseUsers(optionsList);
    }
    return parseTechnicianGroups(technicalGroupList);
  };

  if (id === 'status') {
    return (
      <Checkbox
        toggle
        name={id}
        value={currentForm[id]}
        onChange={onChangeInputValue}
        checked={currentForm[id] === 'A'}
      />
    );
  } else if ((type === 'groupTechnician' && id === 'area') || id === 'relatedUser' || id === 'technicianId') {
    const parseOptions = getParsedoptions(id);

    return (
      <Dropdown
        selection
        search
        required
        value={currentForm[id]}
        name={id}
        onChange={onChangeInputValue}
        options={parseOptions}
      />
    );
  }
  if (id !== 'actions') {
    return (
      <Input
        required
        disabled={
          loadingDetail || (!addInfo && id !== 'description') || disableField
        }
        value={currentForm[id] || ''}
        name={id}
        onChange={onChangeInputValue}
      />
    );
  }
  return (
    <>
      <Icon
        name="save"
        color="green"
        link
        size="big"
        disabled={loadingDetail}
        onClick={saveTechnicianGroup}
      />
      <Icon
        name="cancel"
        color="red"
        disabled={loadingDetail}
        link
        size="big"
        onClick={cancelAddOrEdit}
      />
    </>
  );
};

export default TechnicianGroupForm;
